var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPragAutomat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fd43ce22-cdc2-4171-8989-298b7e400b00",
    "data-name": "toc_automat",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 166.66 199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a0484afd-b053-4756-8b1c-4ae465a350fd,.fc13a9a0-93e1-469d-96e2-e344a631011e{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.fc13a9a0-93e1-469d-96e2-e344a631011e{stroke-width:10px;}.a0484afd-b053-4756-8b1c-4ae465a350fd{stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "prag_automat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a52d9ecb-a1b9-411e-a80b-3b41cfb631ed",
    "data-name": "sticla_2 copy 3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "fc13a9a0-93e1-469d-96e2-e344a631011e",
    points: "91.66 137.63 91.66 185 60.91 185 60.91 5 161.66 5 161.66 185 131.66 185 131.66 137.63 91.66 137.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "fc13a9a0-93e1-469d-96e2-e344a631011e",
    x1: 111.48,
    y1: 155.84,
    x2: 111.48,
    y2: 194
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "abdde8c7-9f0e-4c5d-8ec3-90254cae68df",
    "data-name": "Arrow copy 7"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a0484afd-b053-4756-8b1c-4ae465a350fd",
    x1: 25.16,
    y1: 90.5,
    x2: 25.16,
    y2: 183.49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,149.32a2.49,2.49,0,0,1,3.45.76L40.5,182.35l20.55-32.27a2.5,2.5,0,0,1,4.22,2.69L42.61,188.34a2.5,2.5,0,0,1-4.22,0L15.73,152.77a2.54,2.54,0,0,1-.39-1.34A2.49,2.49,0,0,1,16.5,149.32Z",
    transform: "translate(-15.34 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPragAutomat);
export default __webpack_public_path__ + "static/media/prag_automat.58cbf72de51be3ca99977bb2b254605d.svg";
export { ForwardRef as ReactComponent };